export default __webpack_public_path__ + "static/media/event-sport-bg.d779ba65.png";